module.exports = __webpack_public_path__ + "static/media/slideMobile02.30fb2f07.jpg";